import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3998_12617)",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 21,
				cy: 21,
				r: 21,
				fill: "#ECF8FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21.0128 9.0301C18.236 9.0301 15.96 11.3253 15.96 14.1872V20.1601H14.28V14.1872C14.28 10.4255 17.2804 7.3501 21.0128 7.3501C24.7311 7.3501 27.72 10.414 27.72 14.1621V20.1601H26.04V14.1621C26.04 11.3137 23.7753 9.0301 21.0128 9.0301Z",
				fill: "#1A8EF9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.76 17.2847C11.76 16.9011 12.071 16.5901 12.4546 16.5901H29.5454C29.929 16.5901 30.24 16.9011 30.24 17.2847V25.4101C30.24 30.5132 26.1031 34.6501 21 34.6501C15.8969 34.6501 11.76 30.5132 11.76 25.4101V17.2847Z",
				fill: "#94DCFF"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 19.74,
				y: 24.1501,
				width: 2.52,
				height: 3.78,
				rx: 1.26,
				fill: "#1A8EF9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21 25.6202C22.1598 25.6202 23.1 24.68 23.1 23.5202C23.1 22.3604 22.1598 21.4202 21 21.4202C19.8402 21.4202 18.9 22.3604 18.9 23.5202C18.9 24.68 19.8402 25.6202 21 25.6202Z",
				fill: "#1A8EF9"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3998_12617",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 42,
			height: 42,
			fill: "white"
		})
	}) })]
});
export default SvgIconLock;
